import React from 'react';
import { Empty } from 'antd';
import { Redirect, useParams } from 'react-router-dom';
import { useQueryClient } from 'react-query';
import RoomModal from '../../components/modals/RoomModal/RoomModal';
import useRoom from '../../queries/useRoom';
import SpinWrapper from '../../../../components/SpinWrapper/SpinWrapper';
import RoomHeader from './components/RoomHeader';
import TabContents from './components/TabContents';
import useChangeModalVisible from '../../../../hooks/useChangeModalVisible';
import { tabs } from './constants/tabs';
import useSetRefreshFn from '../../../../hooks/useSetRefreshFn';
import { roomQueryKeys } from '../../queries/queryKeys';
import styles from './Room.module.scss';

const Room = () => {
  const params = useParams();

  const queryClient = useQueryClient();

  const { visible, showModal, hideModal } = useChangeModalVisible();

  const { data: room, isFetching } = useRoom(params.roomId);

  useSetRefreshFn(() => {
    queryClient.invalidateQueries(roomQueryKeys(params.roomId));
  }, [params.roomId]);

  return (
    <div className={styles.root}>
      <Redirect
        from={`/Offices/facilities/${params.facilityId}/rooms/${params.roomId}`}
        to={`/Offices/facilities/${params.facilityId}/rooms/${params.roomId}/${tabs[0].key}`}
      />
      <SpinWrapper spinning={isFetching}>
        {room && Boolean(Object.keys(room).length) ? (
          <>
            <RoomHeader room={room} onEditRoomClick={showModal} />
            <TabContents />
            <RoomModal
              editingRoom={room}
              visible={visible}
              onOk={hideModal}
              onCancel={hideModal}
            />
          </>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </SpinWrapper>
    </div>
  );
};

export default Room;
